export default "__VITE_ASSET__8d90457d__"